/* tslint:disable */
/* eslint-disable */
/**
 * TOM STORAGE SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { GeneralCargoInventoryDto } from '../model';
// @ts-ignore
import type { GeneralCargoOrderLocationDto } from '../model';
// @ts-ignore
import type { GeneralCargoOutboundValidationResultDto } from '../model';
// @ts-ignore
import type { GeneralCargoStockDto } from '../model';
/**
 * GeneralCargoStocksApi - axios parameter creator
 */
export const GeneralCargoStocksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [customerId] 
         * @param {number} [commodityId] 
         * @param {string} [lotNumber] 
         * @param {number} [packageId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoStocksCreate: async (customerId?: number, commodityId?: number, lotNumber?: string, packageId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/GeneralCargoStocks/Create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            if (commodityId !== undefined) {
                localVarQueryParameter['commodityId'] = commodityId;
            }

            if (lotNumber !== undefined) {
                localVarQueryParameter['lotNumber'] = lotNumber;
            }

            if (packageId !== undefined) {
                localVarQueryParameter['packageId'] = packageId;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoStocksGet: async (id?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/GeneralCargoStocks/Get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoStocksGetAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/GeneralCargoStocks/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [orderId] 
         * @param {number} [cargoItemId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoStocksGetByOrderId: async (orderId?: number, cargoItemId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/GeneralCargoStocks/GetByOrderId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }

            if (cargoItemId !== undefined) {
                localVarQueryParameter['cargoItemId'] = cargoItemId;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [commodityId] 
         * @param {number} [customerId] 
         * @param {string} [lotNumber] 
         * @param {number} [packageId] 
         * @param {boolean} [withOccupancyOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoStocksGetByQueryParams: async (commodityId?: number, customerId?: number, lotNumber?: string, packageId?: number, withOccupancyOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/GeneralCargoStocks/GetByQueryParams`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (commodityId !== undefined) {
                localVarQueryParameter['CommodityId'] = commodityId;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['CustomerId'] = customerId;
            }

            if (lotNumber !== undefined) {
                localVarQueryParameter['LotNumber'] = lotNumber;
            }

            if (packageId !== undefined) {
                localVarQueryParameter['PackageId'] = packageId;
            }

            if (withOccupancyOnly !== undefined) {
                localVarQueryParameter['WithOccupancyOnly'] = withOccupancyOnly;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [commodityId] 
         * @param {number} [customerId] 
         * @param {string} [lotNumber] 
         * @param {number} [packageId] 
         * @param {boolean} [withOccupancyOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoStocksGetInventory: async (commodityId?: number, customerId?: number, lotNumber?: string, packageId?: number, withOccupancyOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/GeneralCargoStocks/GetInventory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (commodityId !== undefined) {
                localVarQueryParameter['CommodityId'] = commodityId;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['CustomerId'] = customerId;
            }

            if (lotNumber !== undefined) {
                localVarQueryParameter['LotNumber'] = lotNumber;
            }

            if (packageId !== undefined) {
                localVarQueryParameter['PackageId'] = packageId;
            }

            if (withOccupancyOnly !== undefined) {
                localVarQueryParameter['WithOccupancyOnly'] = withOccupancyOnly;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [orderIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoStocksGetOrderLocations: async (orderIds?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/GeneralCargoStocks/GetOrderLocations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (orderIds) {
                localVarQueryParameter['orderIds'] = orderIds;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [orderId] 
         * @param {number} [commodityId] 
         * @param {number} [customerId] 
         * @param {string} [lotNumber] 
         * @param {number} [packageId] 
         * @param {number} [quantity] 
         * @param {Array<string>} [unitIds] 
         * @param {Array<string>} [imoClasses] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoStocksValidateOutboundOrder: async (orderId?: number, commodityId?: number, customerId?: number, lotNumber?: string, packageId?: number, quantity?: number, unitIds?: Array<string>, imoClasses?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/GeneralCargoStocks/ValidateOutboundOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (orderId !== undefined) {
                localVarQueryParameter['OrderId'] = orderId;
            }

            if (commodityId !== undefined) {
                localVarQueryParameter['CommodityId'] = commodityId;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['CustomerId'] = customerId;
            }

            if (lotNumber !== undefined) {
                localVarQueryParameter['LotNumber'] = lotNumber;
            }

            if (packageId !== undefined) {
                localVarQueryParameter['PackageId'] = packageId;
            }

            if (quantity !== undefined) {
                localVarQueryParameter['Quantity'] = quantity;
            }

            if (unitIds) {
                localVarQueryParameter['UnitIds'] = unitIds;
            }

            if (imoClasses) {
                localVarQueryParameter['ImoClasses'] = imoClasses;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GeneralCargoStocksApi - functional programming interface
 */
export const GeneralCargoStocksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GeneralCargoStocksApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [customerId] 
         * @param {number} [commodityId] 
         * @param {string} [lotNumber] 
         * @param {number} [packageId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalCargoStocksCreate(customerId?: number, commodityId?: number, lotNumber?: string, packageId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralCargoStockDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalCargoStocksCreate(customerId, commodityId, lotNumber, packageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralCargoStocksApi.generalCargoStocksCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalCargoStocksGet(id?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralCargoStockDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalCargoStocksGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralCargoStocksApi.generalCargoStocksGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalCargoStocksGetAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GeneralCargoStockDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalCargoStocksGetAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralCargoStocksApi.generalCargoStocksGetAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [orderId] 
         * @param {number} [cargoItemId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalCargoStocksGetByOrderId(orderId?: number, cargoItemId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralCargoStockDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalCargoStocksGetByOrderId(orderId, cargoItemId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralCargoStocksApi.generalCargoStocksGetByOrderId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [commodityId] 
         * @param {number} [customerId] 
         * @param {string} [lotNumber] 
         * @param {number} [packageId] 
         * @param {boolean} [withOccupancyOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalCargoStocksGetByQueryParams(commodityId?: number, customerId?: number, lotNumber?: string, packageId?: number, withOccupancyOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GeneralCargoStockDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalCargoStocksGetByQueryParams(commodityId, customerId, lotNumber, packageId, withOccupancyOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralCargoStocksApi.generalCargoStocksGetByQueryParams']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [commodityId] 
         * @param {number} [customerId] 
         * @param {string} [lotNumber] 
         * @param {number} [packageId] 
         * @param {boolean} [withOccupancyOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalCargoStocksGetInventory(commodityId?: number, customerId?: number, lotNumber?: string, packageId?: number, withOccupancyOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GeneralCargoInventoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalCargoStocksGetInventory(commodityId, customerId, lotNumber, packageId, withOccupancyOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralCargoStocksApi.generalCargoStocksGetInventory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<number>} [orderIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalCargoStocksGetOrderLocations(orderIds?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GeneralCargoOrderLocationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalCargoStocksGetOrderLocations(orderIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralCargoStocksApi.generalCargoStocksGetOrderLocations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [orderId] 
         * @param {number} [commodityId] 
         * @param {number} [customerId] 
         * @param {string} [lotNumber] 
         * @param {number} [packageId] 
         * @param {number} [quantity] 
         * @param {Array<string>} [unitIds] 
         * @param {Array<string>} [imoClasses] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalCargoStocksValidateOutboundOrder(orderId?: number, commodityId?: number, customerId?: number, lotNumber?: string, packageId?: number, quantity?: number, unitIds?: Array<string>, imoClasses?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralCargoOutboundValidationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalCargoStocksValidateOutboundOrder(orderId, commodityId, customerId, lotNumber, packageId, quantity, unitIds, imoClasses, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralCargoStocksApi.generalCargoStocksValidateOutboundOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GeneralCargoStocksApi - factory interface
 */
export const GeneralCargoStocksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GeneralCargoStocksApiFp(configuration)
    return {
        /**
         * 
         * @param {GeneralCargoStocksApiGeneralCargoStocksCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoStocksCreate(requestParameters: GeneralCargoStocksApiGeneralCargoStocksCreateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GeneralCargoStockDto> {
            return localVarFp.generalCargoStocksCreate(requestParameters.customerId, requestParameters.commodityId, requestParameters.lotNumber, requestParameters.packageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralCargoStocksApiGeneralCargoStocksGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoStocksGet(requestParameters: GeneralCargoStocksApiGeneralCargoStocksGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GeneralCargoStockDto> {
            return localVarFp.generalCargoStocksGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoStocksGetAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<GeneralCargoStockDto>> {
            return localVarFp.generalCargoStocksGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralCargoStocksApiGeneralCargoStocksGetByOrderIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoStocksGetByOrderId(requestParameters: GeneralCargoStocksApiGeneralCargoStocksGetByOrderIdRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GeneralCargoStockDto> {
            return localVarFp.generalCargoStocksGetByOrderId(requestParameters.orderId, requestParameters.cargoItemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralCargoStocksApiGeneralCargoStocksGetByQueryParamsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoStocksGetByQueryParams(requestParameters: GeneralCargoStocksApiGeneralCargoStocksGetByQueryParamsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<GeneralCargoStockDto>> {
            return localVarFp.generalCargoStocksGetByQueryParams(requestParameters.commodityId, requestParameters.customerId, requestParameters.lotNumber, requestParameters.packageId, requestParameters.withOccupancyOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralCargoStocksApiGeneralCargoStocksGetInventoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoStocksGetInventory(requestParameters: GeneralCargoStocksApiGeneralCargoStocksGetInventoryRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<GeneralCargoInventoryDto>> {
            return localVarFp.generalCargoStocksGetInventory(requestParameters.commodityId, requestParameters.customerId, requestParameters.lotNumber, requestParameters.packageId, requestParameters.withOccupancyOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralCargoStocksApiGeneralCargoStocksGetOrderLocationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoStocksGetOrderLocations(requestParameters: GeneralCargoStocksApiGeneralCargoStocksGetOrderLocationsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<GeneralCargoOrderLocationDto>> {
            return localVarFp.generalCargoStocksGetOrderLocations(requestParameters.orderIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralCargoStocksApiGeneralCargoStocksValidateOutboundOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoStocksValidateOutboundOrder(requestParameters: GeneralCargoStocksApiGeneralCargoStocksValidateOutboundOrderRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GeneralCargoOutboundValidationResultDto> {
            return localVarFp.generalCargoStocksValidateOutboundOrder(requestParameters.orderId, requestParameters.commodityId, requestParameters.customerId, requestParameters.lotNumber, requestParameters.packageId, requestParameters.quantity, requestParameters.unitIds, requestParameters.imoClasses, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for generalCargoStocksCreate operation in GeneralCargoStocksApi.
 */
export interface GeneralCargoStocksApiGeneralCargoStocksCreateRequest {
    readonly customerId?: number

    readonly commodityId?: number

    readonly lotNumber?: string

    readonly packageId?: number
}

/**
 * Request parameters for generalCargoStocksGet operation in GeneralCargoStocksApi.
 */
export interface GeneralCargoStocksApiGeneralCargoStocksGetRequest {
    readonly id?: string
}

/**
 * Request parameters for generalCargoStocksGetByOrderId operation in GeneralCargoStocksApi.
 */
export interface GeneralCargoStocksApiGeneralCargoStocksGetByOrderIdRequest {
    readonly orderId?: number

    readonly cargoItemId?: number
}

/**
 * Request parameters for generalCargoStocksGetByQueryParams operation in GeneralCargoStocksApi.
 */
export interface GeneralCargoStocksApiGeneralCargoStocksGetByQueryParamsRequest {
    readonly commodityId?: number

    readonly customerId?: number

    readonly lotNumber?: string

    readonly packageId?: number

    readonly withOccupancyOnly?: boolean
}

/**
 * Request parameters for generalCargoStocksGetInventory operation in GeneralCargoStocksApi.
 */
export interface GeneralCargoStocksApiGeneralCargoStocksGetInventoryRequest {
    readonly commodityId?: number

    readonly customerId?: number

    readonly lotNumber?: string

    readonly packageId?: number

    readonly withOccupancyOnly?: boolean
}

/**
 * Request parameters for generalCargoStocksGetOrderLocations operation in GeneralCargoStocksApi.
 */
export interface GeneralCargoStocksApiGeneralCargoStocksGetOrderLocationsRequest {
    readonly orderIds?: Array<number>
}

/**
 * Request parameters for generalCargoStocksValidateOutboundOrder operation in GeneralCargoStocksApi.
 */
export interface GeneralCargoStocksApiGeneralCargoStocksValidateOutboundOrderRequest {
    readonly orderId?: number

    readonly commodityId?: number

    readonly customerId?: number

    readonly lotNumber?: string

    readonly packageId?: number

    readonly quantity?: number

    readonly unitIds?: Array<string>

    readonly imoClasses?: Array<string>
}

/**
 * GeneralCargoStocksApi - object-oriented interface
 */
export class GeneralCargoStocksApi extends BaseAPI {
    /**
     * 
     * @param {GeneralCargoStocksApiGeneralCargoStocksCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalCargoStocksCreate(requestParameters: GeneralCargoStocksApiGeneralCargoStocksCreateRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralCargoStocksApiFp(this.configuration).generalCargoStocksCreate(requestParameters.customerId, requestParameters.commodityId, requestParameters.lotNumber, requestParameters.packageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralCargoStocksApiGeneralCargoStocksGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalCargoStocksGet(requestParameters: GeneralCargoStocksApiGeneralCargoStocksGetRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralCargoStocksApiFp(this.configuration).generalCargoStocksGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalCargoStocksGetAll(options?: RawAxiosRequestConfig) {
        return GeneralCargoStocksApiFp(this.configuration).generalCargoStocksGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralCargoStocksApiGeneralCargoStocksGetByOrderIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalCargoStocksGetByOrderId(requestParameters: GeneralCargoStocksApiGeneralCargoStocksGetByOrderIdRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralCargoStocksApiFp(this.configuration).generalCargoStocksGetByOrderId(requestParameters.orderId, requestParameters.cargoItemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralCargoStocksApiGeneralCargoStocksGetByQueryParamsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalCargoStocksGetByQueryParams(requestParameters: GeneralCargoStocksApiGeneralCargoStocksGetByQueryParamsRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralCargoStocksApiFp(this.configuration).generalCargoStocksGetByQueryParams(requestParameters.commodityId, requestParameters.customerId, requestParameters.lotNumber, requestParameters.packageId, requestParameters.withOccupancyOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralCargoStocksApiGeneralCargoStocksGetInventoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalCargoStocksGetInventory(requestParameters: GeneralCargoStocksApiGeneralCargoStocksGetInventoryRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralCargoStocksApiFp(this.configuration).generalCargoStocksGetInventory(requestParameters.commodityId, requestParameters.customerId, requestParameters.lotNumber, requestParameters.packageId, requestParameters.withOccupancyOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralCargoStocksApiGeneralCargoStocksGetOrderLocationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalCargoStocksGetOrderLocations(requestParameters: GeneralCargoStocksApiGeneralCargoStocksGetOrderLocationsRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralCargoStocksApiFp(this.configuration).generalCargoStocksGetOrderLocations(requestParameters.orderIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralCargoStocksApiGeneralCargoStocksValidateOutboundOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalCargoStocksValidateOutboundOrder(requestParameters: GeneralCargoStocksApiGeneralCargoStocksValidateOutboundOrderRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralCargoStocksApiFp(this.configuration).generalCargoStocksValidateOutboundOrder(requestParameters.orderId, requestParameters.commodityId, requestParameters.customerId, requestParameters.lotNumber, requestParameters.packageId, requestParameters.quantity, requestParameters.unitIds, requestParameters.imoClasses, options).then((request) => request(this.axios, this.basePath));
    }
}

